import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";
import { set } from "date-fns";

const FmtcUserCreation = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    
    // Base URL from environment variables
    const baseUrl = `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}`;
    
    // Basic user information
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [designationValue, setDesignationValue] = useState("");
    const [gender, setGender] = useState('');
    const [userCodeLocal, setUserCodeLocal] = useState("");
    const [emailValue, setEmailValue] = useState("");
    
    // FMTC and State related
    const [fmtcValue, setFmtcValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    
    // Data arrays
    const [fmtcData, setFmtcData] = useState([]);
    const [statesData, setStatesData] = useState([]);
    const [designationData, setDesignationData] = useState([]);
    
    // User type selection
    const [userTypeValue, setUserTypeValue] = useState("");
    
    // Initialize FMTTI data with session storage values
    const initialFmttiData = useMemo(() => {
        const fmttiCode = sessionStorage.getItem("fmttiCode");
        const fmttiName = sessionStorage.getItem("fmttiName");
        const userRoleCodeModel = sessionStorage.getItem("userTypeCodeModel");
        console.log("Initial FMTTI data from session:", { fmttiCode, fmttiName, userRoleCodeModel });
        if (fmttiCode && fmttiName) {
            return [{
                fmtticode: fmttiCode,
                fmttiname: fmttiName
            }];
        }
        return [];
    }, []);

    const [fmttiData, setFmttiData] = useState(initialFmttiData);
    const [fmttiValue, setFmttiValue] = useState(sessionStorage.getItem("fmttiCode") || "");
    
    useEffect(() => {
        //alert(sessionStorage.getItem("userNameModel"));
        // Initialize values from session storage
        const sessionFmttiCode = sessionStorage.getItem("fmttiCode");
        const sessionFmttiName = sessionStorage.getItem("fmttiName");
        const sessionUserName = sessionStorage.getItem("userNameModel");

        
        console.log("Session values:", {
            fmttiCode: sessionFmttiCode,
            fmttiName: sessionFmttiName,
            userName: sessionUserName
        });

        if (sessionFmttiCode && sessionFmttiName) {
            setFmttiValue(sessionFmttiCode);
            setFmttiData([{
                fmtticode: sessionFmttiCode,
                fmttiname: sessionFmttiName
            }]);
        }

        fetchDesignation();
        fetchFmtcData();
        fetchStates();
        fetchFmttiData();
    }, []);

    useEffect(() => {
        // useEffect to set defaultValue in dropdown menu for edit mode
        if (state) {
            console.log("state$$$", state)
            setUserNameValue(state.cropSurveyCode.userName);
            setMobileValue(state.cropSurveyCode.mobile)
            setDesignationValue(state.cropSurveyCode.designationCode);
            setUserCodeLocal(state.cropSurveyCode.userCode);
            setGender(state.cropSurveyCode.gender)
            setFmtcValue(state.cropSurveyCode.fmtcCode);
          //  setFmttiValue(state.cropSurveyCode.fmttiCode);
            setStateValue(state.cropSurveyCode.stateCode);
            setEmailValue(state.cropSurveyCode.emailId || "");
            setUserTypeValue(state.cropSurveyCode.userRoleCode);
        }
    }, []);

    useEffect(() => {
        // After fetching all FMTTIs, filter to only the one from session
        const code = sessionStorage.getItem("fmttiCode");
        if (code && fmttiData.length > 0) {
            setFmttiValue(code);
        }
    }, [fmttiData]);

    const fetchDesignation = async () => {
        try {
            const result = await axios(
                `${baseUrl}/api/Management/commDesignation`
            );
            setDesignationData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    };

    const fetchFmtcData = async () => {
        try {
            console.log("Fetching FMTC data...");
            
            // Get and validate fmtticode from session
            const fmttiCode = sessionStorage.getItem("fmttiCode");
            console.log("FMTTI Code from session:", fmttiCode);
            
            if (!fmttiCode || fmttiCode === "null" || fmttiCode === "undefined") {
                console.error("Invalid or missing fmttiCode in session storage");
                alert("FMTTI code not found. Please login again.");
                setFmtcData([]);
                return;
            }
            
            const payload = {
                "fmtccode": 0,
                "fmtcname": "",
                "fmtticode": Number(fmttiCode)
            };
            
            console.log("FMTC API Request payload:", payload);
            
            const response = await axios.post(
                `${baseUrl}/api/MT/GetFmtc`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            );
            
            console.log("FMTC API response:", response.data);
            
            if (response.data && response.data.success && response.data.dataContent) {
                const fmtcList = response.data.dataContent;
                if (Array.isArray(fmtcList) && fmtcList.length > 0) {
                    console.log("FMTC data loaded successfully:", fmtcList);
                    setFmtcData(fmtcList);
                } else {
                    console.error("FMTC data is empty or invalid format");
                    setFmtcData([]);
                }
            } else {
                console.error("Invalid FMTC API response format");
                setFmtcData([]);
            }
        } catch (error) {
            console.error("Error fetching FMTC data:", error);
            setFmtcData([]);
            if (error.response) {
                console.error("Error response:", error.response.data);
                console.error("Error status:", error.response.status);
            }
        }
    };

    const fetchStates = async () => {
        try {
            const result = await axios(
                `${baseUrl}/api/states`
            );
            // Filter states to only include the specified ones
            // const allStates = result.data.dataContent;
            // const filteredStates = allStates.filter(state => 
            //     ['Delhi', 'Punjab', 'Haryana', 'Madhya Pradesh', 'Uttar Pradesh'].includes(state.stateName)
            // );
            // console.log("Filtered states:", filteredStates);
            // setStatesData(filteredStates);
            setStatesData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchFmttiData = async () => {
        try {
            // Get the session FMTTI code and name
            const sessionFmttiCode = sessionStorage.getItem("fmttiCode");
            const sessionFmttiName = sessionStorage.getItem("fmttiName");
            console.log("Session FMTTI Data:", {
                code: sessionFmttiCode,
                name: sessionFmttiName
            });
            
            // Fetch all FMTTI data from API
            const response = await axios.get(
                `${baseUrl}/api/MT/GetFmtti`
            );
            
            if (response.data && response.data.dataContent) {
                const fmttiList = response.data.dataContent;
                console.log("FMTTI List Data:", fmttiList);
                
                if (Array.isArray(fmttiList) && fmttiList.length > 0) {
                    // If we have session data, make sure it's included in the list
                    if (sessionFmttiCode && sessionFmttiName) {
                        const sessionFmttiExists = fmttiList.some(item => 
                            String(item.fmtticode) === String(sessionFmttiCode)
                        );
                        
                        if (!sessionFmttiExists) {
                            fmttiList.unshift({
                                fmtticode: sessionFmttiCode,
                                fmttiname: sessionFmttiName
                            });
                        }
                    }
                    
                    setFmttiData(fmttiList);
                    
                    // Set the FMTTI value if we have it in session
                    if (sessionFmttiCode) {
                        console.log("Setting FMTTI Value to:", sessionFmttiCode);
                        setFmttiValue(sessionFmttiCode);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching FMTTI data:", error);
            // If API fails, at least show the session data
            const sessionFmttiCode = sessionStorage.getItem("fmttiCode");
            const sessionFmttiName = sessionStorage.getItem("fmttiName");
            if (sessionFmttiCode && sessionFmttiName) {
                setFmttiData([{
                    fmtticode: sessionFmttiCode,
                    fmttiname: sessionFmttiName
                }]);
                setFmttiValue(sessionFmttiCode);
            } else {
                setFmttiData([]);
            }
        }
    };

    function ValidateAddUser() {
        console.log("ValidateAddUser function called");
        let valid = false;

        try {
            // User type validation
            if (!userTypeValue || userTypeValue === "NA") {
                alert("Please select a user type");
                valid = false;
                return;
            }

            // FMTTI validation
            if (!fmttiValue || fmttiValue === "NA") {
                alert("Please select an FMTTI");
                valid = false;
                return;
            }

            // FMTC validation - Only required for FMTC User type
            if (userTypeValue === "7" && (!fmtcValue || fmtcValue === "NA")) {
                alert("Please select an FMTC");
                valid = false;
                return;
            }

            // State validation
            if (!stateValue || stateValue === "NA") {
                alert("Please select a state");
                valid = false;
                return;
            }

            // User name validation
            if (!userNameValue) {
                alert("Please enter a valid user name");
                valid = false;
                return;
            }

            // Designation validation
            if (!designationValue || designationValue === "Choose...") {
                alert("Please select a designation");
                valid = false;
                return;
            }

            // Mobile validation
            if (!mobileValue || document.getElementById("mobilenumber").style.borderColor === "red") {
                alert("Please enter a valid 10-digit mobile number");
                valid = false;
                return;
            }
             // Email validation
            if(emailValue === "" || emailValue.length < 5 || !validateEmail(emailValue)) {
                alert("Please enter a valid Email ID");
                return;
            }
            // Gender validation
            if (!gender) {
                alert("Please select a gender");
                valid = false;
                return;
            }
 function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
            valid = true;
            console.log("Validation successful, calling", state ? "UpdateUser" : "AddNewUser");
            console.log("Current values:", {
                fmttiValue,
                fmtcValue,
                stateValue,
                userNameValue,
                designationValue,
                mobileValue,
                gender
            });

            if (valid) {
                state ? UpdateUser() : AddNewUser();
            }
        } catch (error) {
            console.error("Error in ValidateAddUser:", error);
            alert("An error occurred during validation. Please check console for details.");
        }
    }

    function AddNewUser() {
        console.log("AddNewUser function called with values:", {
            fmttiValue,
            fmtcValue,
            userNameValue,
            mobileValue,
            designationValue,
            stateValue,
            gender,
            emailValue
        });
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Create payload for FMTC user
            const payload = {
                "entity": "MT",
                "createdOnByUC": currentDate,
                "createdByUC": Number(sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": null,
                "modifiedByUC": 0,
                "userRoleCode": userTypeValue,
                "userCode": 0,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "", // Setting password same as mobile number
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue || "",
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": "0",
                "subDistrictCode": "0",
                "blockCode": "0",
                "villageCode": "0",
                "userTypeCode": "1",
                "schemeCode": "16",
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": Number(fmttiValue),
                "fmtcCode": userTypeValue === "7" ? Number(fmtcValue) : 0,
                "atariCode": 0,
                "kvkCode": 0
            };
            
            console.log("API Payload before stringify:", payload);
            var raw = JSON.stringify(payload);
            console.log("API Payload after stringify:", raw);

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow",
            };

            const apiUrl = `${baseUrl}/api/MT/Users`;
            
            fetch(
              apiUrl,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("Raw API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    console.log("Parsed API Response:", jsonResult);
                    if (jsonResult.success === true) {
                        alert(jsonResult.message || "FMTC User created successfully");
                        console.log("FMTC User created successfully, navigating to user list");
                        navigate("/MNT/UsrListMnT");
                    } else {
                        alert(jsonResult.message || "Failed to create FMTC user");
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                alert("Error communicating with server");
              });
        } catch (error) {
            console.error("Error in AddNewUser:", error);
            alert("An error occurred while creating user. Please check console for details.");
        }
    }

    function UpdateUser() {
        console.log("UpdateUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();
            console.log("Current date being used:", currentDate);

            // Create payload for FMTC user update
            const payload = {
                "entity": "MT",
                "createdOnByUC": currentDate,
                "createdByUC": Number(sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": null,
                "modifiedByUC": Number(sessionStorage.getItem("userCodeModel")),
                "userRoleCode": userTypeValue,
                "userCode": Number(userCodeLocal),
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue || "",
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(stateValue),
                "districtCode": "",
                "subDistrictCode": "",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": "1", // FMTC user type
                "schemeCode": "16",
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "897678",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": Number(fmttiValue),
                "fmtcCode": userTypeValue === "7" ? Number(fmtcValue) : 0,
                "atariCode": 0,
                "kvkCode": 0
            };
            
            console.log("API Payload for update:", payload);
            var raw2 = JSON.stringify(payload);

            var requestOptions = {
              method: "PUT",
              headers: myHeaders,
              body: raw2,
              redirect: "follow",
            };

            const apiUrl = `${baseUrl}/api/MT/Users`;
            console.log("Sending API request to update user:", apiUrl);
            
            fetch(
              apiUrl,
              requestOptions
            )
              .then((response) => {
                console.log("API Response status:", response.status);
                return response.text();
              })
              .then((result) => {
                console.log("API Response:", result);
                try {
                    const jsonResult = JSON.parse(result);
                    alert(jsonResult.message);
                    if (jsonResult.success === true) {
                        console.log("FMTC User updated successfully, navigating to user list");
                        navigate("/MNT/FmtcUserView");
                    }
                } catch (error) {
                    console.error("Error parsing API response:", error);
                    alert("Error processing server response");
                }
              })
              .catch((error) => {
                console.error("API call error:", error);
                alert("Error communicating with server");
              });
        } catch (error) {
            console.error("Error in UpdateUser:", error);
            alert("An error occurred while updating user. Please check console for details.");
        }
    }

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal)
    }

    function validateMobile() {
       if (mobileValue.length === 10) {
          document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
          document.getElementById("mobilenumber").style.borderColor = "red";
        }
    }

    function handleUserName(e) {
      setUserNameValue(e.target.value);
    }

    function handleEmail(e) {
        setEmailValue(e.target.value);
    }

    // Update the FMTC dropdown handler
    const handleFmtcChange = (e) => {
        const selectedValue = e.target.value;
        console.log("FMTC Selection - Selected value:", selectedValue);
        
        // Find the selected FMTC object
        const selectedFmtc = fmtcData.find(
            (item) => String(item.fmtccode || item.FmtcCode || item.fmtcCode) === String(selectedValue)
        );
        console.log("FMTC Selection - Selected FMTC object:", selectedFmtc);
        
        setFmtcValue(selectedValue);
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt /> 
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>FMTC User Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">FMTC User Creation</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        case 2: return "CRM";
                                        case 3: return "SMAM";
                                        default: return "";
                                    }
                                })()}
                            </li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        {/* Select FMTTI */}
                                        <div className='col-md-4'>
                                            <label className="form-label">Select FMTTI</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={fmttiValue || "NA"}
                                                disabled
                                            >
                                                <option value="NA">Choose...</option>
                                                {fmttiData && fmttiData.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.fmtticode}>
                                                            {item.fmttiname}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">User Type</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select'
                                                value={userTypeValue}
                                                onChange={(e) => {
                                                    setUserTypeValue(e.target.value);
                                                    // Reset FMTC value when changing user type
                                                    if (e.target.value !== "7") {
                                                        setFmtcValue("");
                                                    }
                                                }}
                                            >
                                                <option value="NA">Choose...</option>
                                                <option value="7">FMTC User</option>
                                                <option value="5">Surveyor</option>
                                            </select>
                                        </div>
                                        {/* Select FMTC - Only visible for FMTC User */}
                                        {userTypeValue === "7" && (
                                            <div className='col-md-4'>
                                                <label className="form-label">Select FMTC</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className='form-select' 
                                                    value={fmtcValue || "NA"}
                                                    onChange={handleFmtcChange}
                                                >
                                                    <option value="NA">Choose...</option>
                                                    {fmtcData.map((item, index) => {
                                                        const code = item.fmtccode || item.FmtcCode || item.fmtcCode || "";
                                                        const name = item.fmtcname || item.FmtcName || item.fmtcName || "";
                                                        console.log("FMTC Option:", { code, name, item });
                                                        return (
                                                            <option key={index} value={code}>
                                                                {name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        )}
                                        
                                        {/* State Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">State Name</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={stateValue}
                                                onChange={(e) => setStateValue(e.target.value)}
                                            > 
                                                <option value={"NA"}>Choose...</option>
                                                {statesData.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.stateCode}>
                                                            {item.stateName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        
                                        {/* User Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='User Name' 
                                                type='text' 
                                                className='form-control' 
                                                onChange={(e) => handleUserName(e)} 
                                                value={userNameValue} 
                                                maxLength={50} 
                                                readOnly={state ? true : false}
                                            />
                                        </div>
                                        
                                        {/* Designation */}
                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                              Designation
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="Designation"
                                              required
                                              className="form-select"
                                              onChange={(e) => setDesignationValue(e.target.value)}
                                              value={designationValue}
                                            >
                                              <option defaultValue>Choose...</option>
                                              {designationData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.desigCode}>
                                                    {item.desigName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                        </div>
                                        
                                        {/* Mobile No */}
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                              Mobile No
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="mobilenumber"
                                              required
                                              placeholder="Mobile No."
                                              onChange={(e) => handleMobileNumber(e.target.value)}
                                              value={mobileValue}
                                              onKeyUp={validateMobile}
                                              maxLength="10"
                                              readOnly={state ? true : false}
                                            />
                                        </div>
                                         {/* Email Id */}
                                        <div className="col-md-4">
                                            <label htmlFor="emailId" className="form-label">
                                              Email Id
                                            </label>
                                            <input
                                              type="email"
                                              className="form-control"
                                              id="emailId"
                                              placeholder="Email Id"
                                              onChange={(e) => handleEmail(e)}
                                              value={emailValue}
                                            />
                                        </div>
                                  
  
                                        {/* Gender */}
                                        <div className="col-md-4">
                                            <div className="col-md-12">
                                              <label htmlFor="gender" className="form-label">
                                                Gender
                                              </label><label style={{color : "red"}}>*</label>
                                            </div>
                                            <div className="col-md-12">
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("M");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio1"
                                                  value="male"
                                                  checked={gender === "M"}
                                                  onChange={() => setGender("M")}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio1"
                                                >
                                                  Male
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("F");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio2"
                                                  value="female"
                                                  checked={gender === "F"}
                                                  onChange={() => setGender("F")}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio2"
                                                >
                                                  Female
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("T");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio3"
                                                  value="transgender"
                                                  checked={gender === "T"}
                                                  onChange={() => setGender("T")}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio3"
                                                >
                                                  Other
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                    </div>
                                    
                                    {/* Action Buttons */}
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                                        {state ? (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Update FMTC User
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={() => {
                                              console.log("Create FMTC User button clicked");
                                              ValidateAddUser();
                                            }}
                                          >
                                            Create FMTC User
                                          </button>
                                        )}

                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() => navigate("/MNT/FmtcUserView")}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <AdminFooterNew /> 
        </>
    );
};

export default FmtcUserCreation; 